<script setup>
import Sugar from "sugar"
Sugar.extend({
  namespaces: [Date]
})
const device = useDisplay();
const drawer = ref(false)
function toggleMenu() {
  drawer.value = !drawer.value
}
const display = useDisplay()
const permanent = computed(() => {
  return !(display.mobile.value || display.smAndDown.value)
})
const showDrawer = computed(()=>{
  return permanent.value || drawer.value
})
</script>

<template>
  <div>
    <v-card class="center">
      <v-layout>
        <v-app>
          <app-bar @showMenu="toggleMenu"></app-bar>
          <app-nav :drawer="showDrawer" :permanent="permanent" @showMenu="toggleMenu"></app-nav>
          <v-main style="--v-layout-top:52px">
            <v-container>
              <v-sheet max-width="100vw" min-height="90vh">
                <app-bread-crumbs></app-bread-crumbs>
                <slot />
              </v-sheet>
            </v-container>
            <v-divider />
            <app-footer />
          </v-main>
        </v-app>
      </v-layout>
    </v-card>
    <app-dialog></app-dialog>
  </div>
</template>

<style>
.align-left {
  float: left;
}
.text-title{
 color:gray; 
}
.center {
  margin: auto;
  max-width: 1700px;
  padding: 1px;
}
.v-toolbar__content {
  border-bottom-width: 1px;
  border-bottom: 1px solid lightgray;
}

@media (max-width:1280px) {
  .center {
    min-width: 100vw;
  }
}
</style>